import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from '@core/services';
import { Store } from '@ngrx/store';
import {
  selectTheme,
  selectThemeError,
  selectIsLoadingTheme,
} from '@store/selectors/theme.selectors';

@Component({
  selector: 'shared-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './title.component.html',
})
export class TitleComponent {
  private config = inject(ConfigService);
  private readonly store = inject(Store);

  public readonly isLoadingTheme =
    this.store.selectSignal(selectIsLoadingTheme);
  public readonly theme = this.store.selectSignal(selectTheme);
  public readonly errorTheme = this.store.selectSignal(selectThemeError);
}
